module.exports = __webpack_public_path__ + "img/shopTopImg.04379678.jpg";